export default (initialItem = {}) => ({
    // Получаем данные:
    // 1. Либо из переданного аргумента (если инициализировали x-data="quantitySelector(item)")
    // 2. Либо "магически" из контекста Alpine (item из x-for)
    get currentVal() {
        return (
            this.optimisticQty ?? (this.item?.quantity || initialItem.quantity)
        );
    },
    itemId: initialItem?.id,

    get item() {
        return Alpine.store('cart').getItem(this.itemId);
    },

    get changeQuantity() {
        return this.item?.productVariation?.packHalfQuantity ?? 1;
    },

    get stockQuantity() {
        return this.item?.productVariation?.stockQuantity ?? 0;
    },

    optimisticQty: null,
    loading: false,
    focused: false,
    editValue: '',
    debounceTimer: null,

    async update(qty) {
        if (qty < 1 || this.loading) return;

        if (!this.item?.productVariation?.isMss) {
            if (qty > this.stockQuantity) qty = this.stockQuantity;
        }

        const previousQty = this.item.quantity;
        this.optimisticQty = qty;
        this.loading = true;

        try {
            await Alpine.store('cart').updateQuantity(this.item.id, qty);
        } catch (e) {
            console.error(e);
            this.optimisticQty = previousQty;
        } finally {
            this.loading = false;
        }
    },

    change(delta) {
        const baseVal = this.optimisticQty ?? this.item.quantity;
        let qty = baseVal + delta;
        if (delta < 0 && baseVal % Math.abs(delta) !== 0) {
            qty = baseVal - (baseVal % Math.abs(delta));
        }

        this.update(qty).then();
    },

    onFocus() {
        this.editValue = this.currentVal.toString();
        this.focused = true;
    },

    onInput(e) {
        this.editValue = e.target.value;
        const parsed = parseInt(this.editValue, 10);

        if (this.debounceTimer) clearTimeout(this.debounceTimer);

        if (!isNaN(parsed) && parsed >= 1) {
            this.debounceTimer = setTimeout(() => {
                this.update(parsed);
                this.debounceTimer = null;
            }, 700);
        }
    },

    onBlur() {
        this.focused = false;
        if (this.debounceTimer) clearTimeout(this.debounceTimer);

        const parsed = parseInt(this.editValue, 10);
        if (!isNaN(parsed) && parsed >= 1 && parsed !== this.currentVal) {
            this.update(parsed);
        } else {
            this.editValue = this.currentVal.toString();
        }
    },

    refresh(item) {
        this.item = item;
    },
});
